
import { fonts } from "../../../styles/fonts";
import { colors } from "../../../styles/colors";

const headerWrapper: any = {
    display: "flex",
    flexDirection: "column",
    background: "#f1f4f8",
    paddingBottom: 35
    // justifyContent: "flex-end",
    // padding: "12px 20px",f2f4f8
    // background: colors.white,
    // borderRadius: 0,
    // boxShadow: "0px 0px 13px 0px rgba(0, 0, 0, 0.15)",
}

const titleWrapper = {
    display: "flex",
    gap: 15
}

const titleContainer = {
    display: "flex",
    gap: 15,
    justifyContent: "space-between"
}

const label = {
    color: colors.slateBlue,
    fontFamily: fonts.boldFont,
    fontSize: 12,
    textTransform: "uppercase"
}

const backArrow = {
    marginRight: 5,
    cursor: "pointer"
}

const planWrapper: any = {
    background: colors.white,
    borderRadius: 10,
    boxShadow: "0px 2px 14px 0px rgba(0, 0, 0, 0.1)",
    padding: "30px 0",
    marginTop: 25,
    justifyContent: "space-around",
    display: "grid",
    gridGap: 30,
    paddingLeft: 35,
    gridTemplateColumns: "repeat(auto-fill, minmax(170px,1fr))"
}

const goalPropertyWrapper: any = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start"
}

const planTitle = {
    marginLeft: 35
}

export {
    headerWrapper,
    titleWrapper,
    label,
    backArrow,
    planWrapper,
    goalPropertyWrapper,
    planTitle,
    titleContainer
};